import "./styles.css";

export default function Loader({
  className = "",
}: {
  className?: "app-loader" | "";
}) {
  return <div className={`loader ${className}`}></div>;
}
